import { DataSource } from '@angular/cdk/collections';
import { Observable, BehaviorSubject } from 'rxjs';

import { Report, ReportRecord } from '@app/models/report';



/**
 * Data source for the OwnHistories view. This class should
 * encapsulate all logic for fetching and manipulating the displayed data
 * (including sorting, pagination, and filtering).
 */
export class OwnHistoriesDataSource extends DataSource<ReportRecord> {
  data: Report; // = EXAMPLE_DATA;
  reportSubject: BehaviorSubject<ReportRecord[]>;

  constructor(
    report: Report) {
    super();
    this.data = report;
    this.reportSubject = new BehaviorSubject<ReportRecord[]>(report.data);
  }

  /**
   * Connect this data source to the table. The table will only update when
   * the returned stream emits new items.
   * @returns A stream of the items to be rendered.
   */
  connect(): Observable<ReportRecord[]> {
    return this.reportSubject;
  }

  /**
   *  Called when the table is being destroyed. Use this function, to clean up
   * any open connections or free any held resources that were set up during connect.
   */
  disconnect() { }
}
